import styled from "styled-components";

export const GeneratorChartTickMarkContainer = styled.div<{ left?: number; top?: number; isRotated?: boolean }>`
   
  position: absolute;
  z-index: 0;
  font-size: .9em;
  min-width: max-content;
  display: block;

  .tick-inner {
    padding: .5em;
    line-height: 1;
  }
  &.horizontal {
    transform: translate(-100%, -50%);
    left: 0;
    padding-right: 1em;
    top: ${({ top }) => `${top || 0}px`};
  }

  &.vertical {
    transform: translate(-50%, 60%);
    text-align: center;
    top: 100%;
    left: ${({ left }) => `${left || 0}px`};

    &.is-rotated {
      text-align: right;
      transform: rotate(-45deg) translate(-95%, -17%);   
    }
  }

`